import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';

interface CampaignPageFundraiserStatLineProps {
  icon: IconProp;
  label: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  iconClassName?: string;
}

const CampaignPageFundraiserStatLine = ({
  icon,
  label,
  as: Component = 'div',
  className = '',
  iconClassName = '',
}: CampaignPageFundraiserStatLineProps) => (
  <Component
    className={cx('flex items-center text-gray-700 font-medium leading-snug gap-x-4', className)}
  >
    <span className="w-8 text-center shrink-0">
      <FontAwesomeIcon icon={icon} className={cx('text-2xl', iconClassName)} />
    </span>
    <p className="text-left">{label}</p>
  </Component>
);

export default CampaignPageFundraiserStatLine;
